export const rptEventAnalysis = (events, eventArr) => {
    eventArr = eventArr.sort((a, b) => 
            (a.eventID > b.eventID) ? 1 : -1);  
    let prevEventID = "";
    let eventCount = 0;
    let prevEventFreq = "";
    let dateArr = [];
    let eventList = [];
    // combine same events into a single record
    for (let i=0; i<eventArr.length; i++){
        if (eventArr[i].eventID !== prevEventID){
            if (prevEventID !== ""){
                const eventDates = dateArr.join(', ');
                const eventListObj = {eventID: prevEventID, frequency: prevEventFreq, 
                    eventDates: eventDates, count: eventCount};
                eventList.push(eventListObj);
            }
            prevEventID = eventArr[i].eventID;
            prevEventFreq = eventArr[i].frequency;
            dateArr = [];
            eventCount = 0;
        }
        dateArr.push(eventArr[i].gameDate);
        eventCount += 1;
    }
    const eventDates = dateArr.join(', ');
    const eventListObj = {eventID: prevEventID, frequency: prevEventFreq, 
       eventDates: eventDates, count: eventCount};
    eventList.push(eventListObj);
    let rptArr = [];
    for (let i=0; i<eventList.length; i++){
        if (i === 0){
            const rptArrObj = {eventID: "eventID", frequency: "Frequency",
                eventDates:  "Event Dates", count: "Count",
                title: "Event Title", category: "Category", freqType: "FreqName",
                freqTier: "FreqTier"
            }
            rptArr.push(rptArrObj);
        }
        const eventObj = events.find(item => item.id === eventList[i].eventID);
        if (eventObj){
            const rptArrObj = {...eventList[i], 
                title: eventObj.title, 
                category: eventObj.eventCategory,
                freqType: eventObj.frequencyObj.frequencyType, 
                freqTier: eventObj.frequencyObj.freqPriority }
            rptArr.push(rptArrObj);
        }else{
            const rptArrObj = {...eventList[i],
                title: "event ID not found",
                category: "",
                freqType: "",
                freqTier: ""
            }
            rptArr.push(rptArrObj);
        }
    }
    return rptArr;
    
}
export default rptEventAnalysis;